import templateUrl from 'emun.vendor/vendorgroup-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class VendorGroupListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit() {
        const $ctrl = this;
        $ctrl.query = $ctrl.container.query;
    }
    load() {
        const $ctrl = this;
        return $ctrl.query.load.apply($ctrl.query, arguments);
    }
}

export default {
    bindings: {
    },
    require: {
        container: '^vendorgroupContainer'
    },
    controller: VendorGroupListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};